export default "__VITE_ASSET__DhqRkSTp__"